export default "__VITE_ASSET__c214af33__"